import update from 'immutability-helper';
import { GaugeListType, ReducerHookActionType } from '../../../../@types';
import { sharedReducerHookActionTypes } from '../../../../utils/constants';

export const initState: StateType = {
  loading: true,
  gaugeList: [],
};

export const actionTypes = {
  ...sharedReducerHookActionTypes,
};

export const reducer = (state: StateType, action: ReducerHookActionType) => {
  switch (action.type) {
    case actionTypes.setState: {
      const updatedState = update(state, {
        $merge: { ...action.payload },
      });
      return { ...updatedState };
    }

    default:
      return { ...state };
  }
};

export type StateType = {
  loading: boolean;
  gaugeList: GaugeListType[];
};
